import { DEFAULT_CATEGORIES } from '../utils/gridHelpers.js'

export default function NavigationMode({
  route,
  currentStep,
  onNext,
  onPrev,
  onClose,
  isLastStep,
  progress,
}) {
  if (!route || route.stops.length === 0) return null

  const stop = route.stops[currentStep]
  const cat = DEFAULT_CATEGORIES.find(c => c.id === stop?.category)
  const progressPercent = progress ? (progress.current / progress.total) * 100 : 0

  // Try haptic feedback on step change
  function handleNext() {
    if (navigator.vibrate) navigator.vibrate(30)
    onNext()
  }

  return (
    <div className="nav-mode">
      <div className="nav-mode__header">
        <button className="btn" onClick={onClose}>
          ✕ Sluiten
        </button>

        <div className="nav-mode__progress">
          <div className="nav-mode__progress-bar">
            <div
              className="nav-mode__progress-fill"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <span className="nav-mode__progress-text">
            {progress?.current} / {progress?.total}
          </span>
        </div>
      </div>

      <div className="nav-mode__body">
        <div className="nav-mode__instruction">
          <div className="nav-mode__direction">
            Ga naar
          </div>
          <div
            className="nav-mode__category-name"
            style={{ color: cat?.color || 'var(--color-primary)' }}
          >
            {cat?.name || stop?.category}
          </div>
          <div className="nav-mode__items-list">
            {stop?.items.map((item, i) => (
              <div key={i}>{item}</div>
            ))}
          </div>
        </div>

        {/* Step indicator dots */}
        <div style={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'center',
        }}>
          {route.stops.map((s, idx) => {
            const c = DEFAULT_CATEGORIES.find(ct => ct.id === s.category)
            return (
              <div
                key={idx}
                style={{
                  width: idx === currentStep ? 28 : 10,
                  height: 10,
                  borderRadius: 5,
                  background: idx <= currentStep
                    ? (c?.color || 'var(--color-primary)')
                    : 'var(--color-surface-active)',
                  transition: 'all 0.3s ease',
                }}
              />
            )
          })}
        </div>
      </div>

      <div className="nav-mode__controls">
        <button
          className="btn btn--lg"
          onClick={onPrev}
          disabled={currentStep === 0}
        >
          ◀ Vorige
        </button>
        {isLastStep ? (
          <button
            className="btn btn--success btn--lg"
            onClick={onClose}
          >
            ✓ Klaar!
          </button>
        ) : (
          <button
            className="btn btn--primary btn--lg"
            onClick={handleNext}
          >
            Volgende ▶
          </button>
        )}
      </div>
    </div>
  )
}
